DetailOutput = App.loadClass 'core::reports/DetailOutput'
BaseHandler = App.loadClass 'core::reports/BaseHandler'
ReportsRxAnalysisSummary = App.loadClass 'portal::handlers/reports/ReportsRxAnalysisSummary'

class exports.ReportsNitrogenRxAnalysisSubHandler extends BaseHandler
    init: () ->
        @layoutSelector = '#reports_nitrogen_rx_analysis_tab'
        @excelUrl       = 'backend/portal/reports/nitrogen-rx-analysis/excel'
        @filterUrl      = 'backend/portal/reports/nitrogen-rx-analysis/filters'

        @initFilters()

    initFilters: () ->
        @resetFilters()

        @parent.filters.importGroup
            name: 'Rx Analysis Filters'
            filters: [
                name: 'crops'
                display_name: 'Crop'
                class: 'dropup'
            ,
                name: 'advisor'
                display_name: 'Advisor'
                class: 'dropup'
            ,
                name: 'downloaded_by'
                display_name: 'Downloaded By'
                class: 'dropup'
            ,
                name: 'service_level'
                display_name: 'Service Level'
                class: 'dropup'
            ,
                name: 'output_type'
                display_name: 'Output Type'
                control_type: 'option'
                deletable: false
                values: [
                    { key: 'detail', value: 'Detail' },
                    { key: 'summary', value: 'Summary' }
                ],
                selected_values: [
                    { key: 'summary', value: 'Summary' }
                ],
            ]


        @setDefaultsAndRun()


    destroy: () ->
        # reenable operation filters so they aren't missing for other reports
        @parent.filters.enableGroup('Operation Filters')
        # remove report-specific filters
        @parent.filters.removeGroup 'Rx Analysis Filters'
        super()

    beforeApply: () ->
        filters = @parent.filters.jsonize()

        if filters.filters.output_type[0].key is 'detail'
            @layoutUrl  = 'backend/portal/reports/nitrogen-rx-analysis/table/detail'
            @printUrl   = 'backend/portal/reports/nitrogen-rx-analysis/print/detail'
            @currentOutput = new DetailOutput this, @parent, 'auto', { sAjaxSource: 'backend/portal/reports/nitrogen-rx-analysis/output/detail' }
        else
            @layoutUrl  = 'backend/portal/reports/nitrogen-rx-analysis/output/summary'
            @printUrl   = 'backend/portal/reports/nitrogen-rx-analysis/print/summary'
            @currentOutput = new ReportsRxAnalysisSummary this, @parent
